export default {
    modalGenerateImageVariations: {
        imageAIHeader: "Créer une image à l'aide de l'IA",
        requestFailed: 'La requête a échoué',
        describeYourImage: 'Décrivez votre image',
        numberOfVariations: 'Nombre de variations',
        chooseStyle: "Choisissez votre style d'image",
        descriptionPlaceholder: "(eg) Un champ de fleurs de moutarde par une journée d'été avec des chênes",
        clear: 'Effacer',
        generate: 'Générer',
        seeAll: 'Voir tout',
        tryAnExample: 'Essayez un exemple',
        tryAnother: 'Essayez un autre',
    },
};
